var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3887 20.716C16.0978 21.6972 19.9 19.4859 20.8813 15.7767C21.8625 12.0676 19.6511 8.26538 15.942 7.28415C12.2329 6.30293 8.43061 8.51432 7.44938 12.2234C7.44548 12.2382 7.44163 12.2529 7.43783 12.2677L9.38189 12.2677L6.55514 15.7021L3.91406 12.2678L5.74209 12.2677C5.77425 12.1121 5.81086 11.9564 5.85201 11.8009C7.06661 7.20954 11.7732 4.47217 16.3646 5.68678C20.9559 6.90138 23.6932 11.608 22.4786 16.1993C21.264 20.7906 16.5574 23.528 11.9661 22.3134C9.69155 21.7117 7.87201 20.253 6.76255 18.3758L8.27061 17.6761C9.17341 19.1244 10.6086 20.2451 12.3887 20.716ZM14.5244 10.4822H12.9609V15.1726L12.9608 15.1728L17.0229 17.5181L17.8047 16.1641L14.5244 14.2702V10.4822Z",
    fill: "#FAE232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryHighlighted);
export default __webpack_public_path__ + "static/media/history_highlighted.1f01a80369f4fdf4fdcad62bfaa8ab02.svg";
export { ForwardRef as ReactComponent };